import axios from '@/utils/http'

/**
 *
 * 获取菜品列表
 * @export
 * @param {*} params
 * @returns
 */
export function getMenuList (params) {
  return axios({
    url: '/AccountManageService/CompanyMenuManage/GetCompanyMenus',
    method: 'get', // default
    params: {
      ...params
    }
  })
}

/**
 *
 * 获取菜品的食材
 * @export
 * @param {*} params
 * @returns
 */
export function GetMenuFoods (params) {
  return axios({
    url: '/MenuService/MenuManage/GetMenuFoods',
    method: 'get',
    params: {
      ...params
    }
  })
}

/**
 *
 * 获取营养套餐
 * @export
 * @param {*} params
 * @returns
 */
export function getNutritionPackages (params) {
  return axios({
    url: '/AccountManageService/CommonPackageManage/GetCommonPackages',
    method: 'get',
    params: {
      ...params
    }
  })
}

/**
 *
 * 菜品模糊搜索
 * @export
 * @param {*} params
 * @returns
 */
export function getPublicMenuByName (params) {
  return axios({
    url: '/AccountManageService/CommonPackageManage/GetCommonMenuByName',
    method: 'get',
    params: {
      ...params
    }
  })
}

/**
 *
 * 添加营养套餐提交
 * @export
 * @param {*} params
 * @returns
 */
export function addNutritionPackage (params) {
  return axios({
    url: '/AccountManageService/CommonPackageManage/AddPackage',
    method: 'post',
    data: {
      ...params
    }
  })
}

/**
 *
 *  修改营养套餐提交
 * @export
 * @param {*} params
 * @returns
 */
export function editNutritionPackage (params) {
  return axios({
    url: '/AccountManageService/CommonPackageManage/EditPackage',
    method: 'post',
    data: {
      ...params
    }
  })
}

/**
 *
 *  企业添加营养套餐时先检验所加菜品是否平衡
 * @export
 * @param {*} params
 * @returns
 */
export function checkChoosedMenus (params) {
  return axios({
    url: '/MenuService/PackageManage/AutonomySetMealAnalysis',
    method: 'get',
    params: {
      ...params
    }
  })
}
